var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clue3-wrap"},[_c('img',{staticClass:"clue3",attrs:{"src":require("../assets/images/clue3/clue3.jpg"),"alt":"clue3"}})])}]

export { render, staticRenderFns }